// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_94eb7","content":"b89d3"};